var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhistle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Whistle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.78 7.5c-.44 0-.74-.3-.74-.75s.3-.75.74-.75c.45 0 .74.3.74.75s-.3.75-.74.75zm-7.84 5.1l-2.36-2.4 1.03-1.05 2.37 2.4-1.04 1.05zM23 6.75a2.2 2.2 0 00-2.22-2.25c-.96 0-1.77.67-2.07 1.5a7.95 7.95 0 00-1.4-.6c-4.07-1.13-6.51 2.25-6.58 2.47L2 16.66 6.29 21l5.62-4.27c.66.52 1.4.9 2.22 1.12 3.25.9 6.65-1.13 7.61-4.58.37-1.5.22-3-.3-4.34A2.3 2.3 0 0023 6.75zM7.47 8.25l-3.7-.75v2.25L7.47 9v-.75zm0-2.03L5.47 3l-1.7 1.72 3.18 2.1.52-.6zm2.22.53L10.43 3H8.21l.74 3.75h.74z",
    fill: "#797979"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhistle);
export default __webpack_public_path__ + "static/media/whistle.0fdcdf3c3cdb5832d0b13e2d2b4d9a17.svg";
export { ForwardRef as ReactComponent };